
import {defineComponent,ref,watch,PropType} from 'vue';
import moment from 'moment';
import repository from '@/services/BenhNhanRepository';
import {useToast} from 'primevue/usetoast';
export default defineComponent({
  props:{khoa:{type:Number,required:true},ngay:{type:Date as PropType<Date>},refreshKey:{type:Number,default:0}},
  emits:['open'],
  setup(props,{emit,expose}) {
    const toast=useToast(),items=ref([]),total=ref(0),page=ref(0),loading=ref(false),busy=ref(false),allDates=ref(false);
    const showExports=ref(false),selectedId=ref(0),exports=ref([]);
    let generation=0;
    const utc=(s:string)=>s?moment.utc(s).local().format('DD/MM/YYYY HH:mm:ss'):'';
    const tai=async()=>{
      const khoa=props.khoa,version=++generation;
      if(!khoa){items.value=[];total.value=0;return;}
      loading.value=true;
      try{const r=await repository.getLichSuChiaGio(khoa,!allDates.value&&props.ngay?moment(props.ngay).format('YYYY-MM-DD'):undefined,page.value+1,10);
        if(version!==generation||khoa!==props.khoa)return;items.value=r.data.items;total.value=r.data.total;
      }catch(err){if(version===generation)toast.add({severity:'error',summary:'Không tải được lịch sử chia giờ',detail:err.response?.data||'Vui lòng thử lại',life:4000});}
      finally{if(version===generation)loading.value=false;}
    };
    const doiTrang=(p:number)=>{page.value=p;tai();};
    const doc=async(id:number,log:boolean)=>{
      if(busy.value)return;const khoa=props.khoa;busy.value=true;
      try{const r=await repository.getChiTietLichSu(khoa,id);if(khoa!==props.khoa)return;
        if(log){selectedId.value=id;exports.value=r.data.lanXuats;showExports.value=true;}else emit('open',r.data.ketQua);
      }catch(err){toast.add({severity:'error',summary:'Không đọc được lịch sử',detail:err.response?.data||'Vui lòng thử lại',life:4000});}
      finally{busy.value=false;}
    };
    const xuat=async(id:number)=>{
      if(busy.value)return;const khoa=props.khoa;busy.value=true;
      try{const r=await repository.xuatLaiLichSu(khoa,id);const url=URL.createObjectURL(r.data),a=document.createElement('a');a.href=url;a.download=`ChiaGio_Khoa${khoa}_Lan${id}.xlsx`;document.body.appendChild(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);if(khoa===props.khoa)await tai();}
      catch(err){const data=err.response?.data;toast.add({severity:'error',summary:'Không xuất được lịch sử',detail:data instanceof Blob?await data.text():data||'Vui lòng thử lại',life:4000});}
      finally{busy.value=false;}
    };
    watch([()=>props.khoa,()=>props.ngay,()=>props.refreshKey,allDates],()=>{page.value=0;items.value=[];showExports.value=false;tai();},{immediate:true});
    expose({tai});
    return{moment,utc,items,total,page,loading,busy,allDates,showExports,selectedId,exports,tai,doiTrang,doc,xuat};
  }
});
